import { getLPAccount } from "@services/lp/account";
import { getLPInfo, putLPInfo } from "@services/lp/info";
import { getLPPosition } from "@services/lp/position";
import { getLPPositionRec } from "@services/lp/position-rec";
import {
    deleteLPSymbolMap,
    getLPSymbolMap,
    updateLPSymbolMap,
} from "@services/lp/symbol-map";
import i18n from "@/i18n";

const state = {
    loading: false,
    accountLoading: false,
    positionLoading: false,
    lpList: [],
    accountHeader: [
        {
            text: "LP",
            value: "LP",
            align: "left",
            width: 120,
            class: ["fixCol_first", "header"],
        },
        {
            text: i18n.t("common.table.marginPercent"),
            value: "Margin_Utilization",
            align: "right",
            width: 100,
        },
        {
            text: i18n.t("common.table.used"),
            value: "Margin",
            align: "right",
            width: 120,
        },
        {
            text: i18n.t("common.table.free"),
            value: "Free_Margin",
            align: "right",
            width: 120,
        },
        {
            text: i18n.t("common.table.equity"),
            value: "Equity",
            align: "right",
            width: 120,
        },
        {
            text: i18n.t("common.table.fpnl"),
            value: "Unrealized_PNL",
            align: "right",
            width: 140,
        },
        {
            text: i18n.t("common.table.balance"),
            value: "Balance",
            align: "right",
            width: 120,
        },
        {
            text: i18n.t("common.table.credit"),
            value: "Credit",
            align: "right",
            width: 100,
        },
        {
            text: i18n.t("common.table.lastUpdate"),
            value: "updated_at",
            align: "left",
            width: 170,
            class: ["fixCol_last", "header"],
        },
    ],
    accountMobileHeader: [
        {
            text: "LP",
            value: "LP",
            align: "left",
            width: 50,
            class: ["fixCol_first", "header"],
        },
        {
            text: "Margin%",
            value: "Margin_Utilization",
            align: "right",
            width: 50,
        },
        { text: "Equity", value: "Equity", align: "right", width: 50 },
        {
            text: "",
            value: "detail",
            align: "right",
            width: 20,
            class: ["fixCol_last", "header"],
        },
    ],
    accountData: [],
    positionHeader: [
        {
            text: "LP",
            value: "LP",
            align: "left",
            width: 80,
            class: ["fixCol_first", "header"],
        },
        {
            text: i18n.t("common.table.symbol"),
            value: "Symbol",
            align: "left",
            width: 150,
        },
        {
            text: i18n.t("common.table.marginRate"),
            value: "Margin_Rate",
            align: "right",
            width: 120,
        },
        {
            text: i18n.t("common.table.position"),
            value: "Position",
            align: "right",
            width: 120,
        },
        {
            text: i18n.t("common.table.totalVwap"),
            value: "Total_VWAP",
            align: "right",
            width: 120,
        },
        {
            text: i18n.t("common.table.margin"),
            value: "Margin",
            align: "right",
            width: 120,
        },
        {
            text: "NOP",
            value: "NOP",
            align: "right",
            width: 80,
        },
        {
            text: i18n.t("common.table.unrealizedPnl"),
            value: "Unrealized_PNL_CCY_Account",
            align: "right",
            width: 120,
        },
        {
            text: i18n.t("common.table.unrealizedPnlQuote"),
            value: "Unrealized_PNL_CCY_Quote",
            align: "right",
            width: 200,
        },
        {
            text: i18n.t("common.table.lastUpdate"),
            value: "updated_at",
            align: "left",
            width: 170,
            class: ["fixCol_last", "header"],
        },
    ],
    positionCsvFields: {
        LP: "LP",
        Symbol: "Symbol",
        "Margin Rate": "Margin_Rate",
        Position: "Position",
        "Total VWAP": "Total_VWAP",
        Margin: "Margin",
        NOP: "NOP",
        "Unrealized P&L": "Unrealized_PNL_CCY_Account",
        "Unrealized P&L in Quote CCY": "Unrealized_PNL_CCY_Quote",
        "Last Update": "updated_at",
    },
    accountCsvFields: {
        LP: "LP",
        "Margin%": "Margin_Utilization",
        Used: "Margin",
        Free: "Free_Margin",
        Equity: "Equity",
        FPNL: "Unrealized_PNL",
        Balance: "Balance",
        Credit: "Credit",
        "Last Update": "updated_at",
    },
    positionMobileHeader: [
        {
            text: "LP",
            value: "LP",
            align: "left",
            width: 50,
            class: ["fixCol_first", "header"],
        },
        {
            text: i18n.t("common.table.symbol"),
            value: "Symbol",
            align: "left",
            width: 50,
        },
        {
            text: i18n.t("common.table.position"),
            value: "Position",
            align: "right",
            width: 50,
        },
        {
            text: i18n.t("common.table.marginRate"),
            value: "Margin_Rate",
            align: "right",
            width: 60,
        },
        {
            text: "",
            value: "detail",
            align: "right",
            width: 20,
            class: ["fixCol_last", "header"],
        },
    ],
    positionData: [],
    recData: [],
    recHeader: [
        {
            text: i18n.t("common.table.symbol"),
            value: "index",
            align: "left",
            width: 120,
        },
        {
            text: i18n.t("common.table.lpVolume"),
            value: "vol_lp",
            align: "right",
            width: 110,
        },
        {
            text: i18n.t("common.table.pkVolume"),
            value: "vol_pk",
            align: "right",
            width: 110,
        },
        {
            text: i18n.t("common.table.difference"),
            value: "diff",
            align: "right",
            width: 110,
        },
        // { text: "Break", value: "break", align: "left", width: 90 },
        // { text: "Last Update", value: "updated_at", align: "left", width: 170 },
    ],
    symbolMapHeader: [
        {
            text: "ID",
            value: "id",
            align: "left",
            width: 60,
        },
        {
            text: i18n.t("common.table.lpName"),
            value: "lp_name",
            align: "left",
            width: 100,
        },
        {
            text: i18n.t("common.table.lpApiName"),
            value: "api_code",
            align: "left",
            width: 120,
        },
        {
            text: i18n.t("common.table.symbol"),
            value: "symbol",
            align: "left",
            width: 120,
        },
        {
            text: i18n.t("common.table.pkName"),
            value: "pk",
            align: "left",
            width: 120,
        },
        {
            text: i18n.t("common.table.multiplier"),
            value: "ratio",
            align: "left",
            width: 80,
        },
        {
            text: i18n.t("common.table.createdAt"),
            value: "created_at",
            align: "left",
            width: 170,
        },
        {
            text: i18n.t("common.table.updatedAt"),
            value: "updated_at",
            align: "left",
            width: 170,
        },
        {
            text: i18n.t("common.table.actions"),
            value: "action",
            align: "left",
            width: 80,
        },
    ],
    symbolMapData: [],
    updateStatus: false,
    batchAddLPId: -1,
    lpTutorial: false,
    lpModule: 0,
};

const actions = {
    /**
     * Get Lp info
     * @param   {[type]}  commit  [commit description]
     * @return  {[type]}          [return description]
     */
    getLPInfoAction({ commit }, params) {
        commit("UPDATE_LOADING", true);

        getLPInfo(params).then((res) => {
            commit("UPDATE_LP_LIST", res.data);
            commit("UPDATE_LOADING", false);
        });
    },
    updateLpInfoAction({ commit, dispatch }, params) {
        commit("UPDATE_LOADING", true);

        putLPInfo(params)
            .then((res) => {
                commit("UPDATE_LP_LIST", []);

                let snackbar = {
                    message: res.data.msg,
                    color: "green",
                    btnName: "Close",
                    status: true,
                    timeout: 2000,
                };
                commit("UPDATE_SNACKBAR", snackbar, { root: true });
                dispatch("getLPInfoAction");
            })
            .catch((err) => {
                commit("UPDATE_LOADING", false);
            });
    },
    /**
     * Load all symbol map
     * @param   {[type]}  commit  [commit description]
     * @param   {[type]}  data    [data description]
     * @return  {[type]}          [return description]
     */
    getLPSymbolMapAction({ commit }, params) {
        commit("UPDATE_LOADING", true);
        getLPSymbolMap(params).then((res) => {
            commit("UPDATE_SYMBOL_MAP_DATA", res.data);
            commit("UPDATE_LOADING", false);
        });
    },
    updateLPSymbolMapAction({ commit }, params) {
        commit("UPDATE_LOADING", true);
        updateLPSymbolMap(params).then((res) => {
            let snackbar = {
                message: res.data.msg,
                color: "green",
                btnName: "Close",
                status: true,
                timeout: 2000,
            };
            commit("UPDATE_SNACKBAR", snackbar, { root: true });
            commit("UPDATE_STATUS", true);
            commit("UPDATE_LOADING", false);
        });
    },
    deleteLPSymbolMapAction({ commit }, params) {
        commit("UPDATE_LOADING", true);
        deleteLPSymbolMap(params).then((res) => {
            let snackbar = {
                message: res.data.msg,
                color: "green",
                btnName: "Close",
                status: true,
                timeout: 2000,
            };
            commit("UPDATE_SNACKBAR", snackbar, { root: true });
            commit("UPDATE_STATUS", true);
            commit("UPDATE_LOADING", false);
        });
    },
    /**
     * Get position rec result
     * @param   {[type]}  commit  [commit description]
     * @return  {[type]}          [return description]
     */
    getLPPositionRecAction({ commit }) {
        commit("UPDATE_LOADING", true);
        getLPPositionRec().then((res) => {
            commit("UPDATE_REC_DATA", res.data);
            commit("UPDATE_LOADING", false);
        });
    },
    /**
     * Get lp account info
     * @param   {[type]}  commit  [commit description]
     * @return  {[type]}          [return description]
     */
    getLPAccountAction({ commit }) {
        commit("UPDATE_ACCOUNT_LOADING", true);
        getLPAccount().then((res) => {
            res.data.forEach((item) => {
                if (typeof item["Balance"] == "string") {
                    item["Balance"] = Number(item["Balance"]);
                }
                if (typeof item["Equity"] == "string") {
                    item["Equity"] = Number(item["Equity"]);
                }
                if (typeof item["Free Margin"] == "string") {
                    item["Free Margin"] = Number(item["Free Margin"]);
                }
                if (typeof item["Margin"] == "string") {
                    item["Margin"] = Number(item["Margin"]);
                }
                if (typeof item["Margin Utilization %"] == "string") {
                    item["Margin Utilization %"] = Number(
                        item["Margin Utilization %"]
                    );
                }
                if (typeof item["Unrealized P&L"] == "string") {
                    item["Unrealized P&L"] = Number(item["Unrealized P&L"]);
                }
            });
            commit("UPDATE_ACCOUNT_DATA", res.data);
            commit("UPDATE_ACCOUNT_LOADING", false);
        });
    },
    /**
     * Get position data
     * @return  {[type]}  [return description]
     */
    getLPPositionAction({ commit }) {
        commit("UPDATE_POSITION_LOADING", true);
        getLPPosition().then((res) => {
            commit("UPDATE_POSITION_DATA", res.data);
            commit("UPDATE_POSITION_LOADING", false);
        });
    },
    updateLpTutorialAction({ state }, data) {
        state.lpTutorial = data;
    },
    updateLPModuleAction({ state }, data) {
        state.lpModule = data;
    },
};

const mutations = {
    /**
     * Update loading status
     * @param   {[type]}  state  [state description]
     * @param   {[type]}  data   [data description]
     * @return  {[type]}         [return description]
     */
    UPDATE_LOADING(state, data) {
        state.loading = data;
    },
    UPDATE_POSITION_LOADING(state, data) {
        state.positionLoading = data;
    },
    UPDATE_ACCOUNT_LOADING(state, data) {
        state.accountLoading = data;
    },
    /**
     * Update account data
     * @param   {[type]}  state  [state description]
     * @param   {[type]}  data   [data description]
     * @return  {[type]}         [return description]
     */
    UPDATE_ACCOUNT_DATA(state, data) {
        state.accountData = data;
    },
    /**
     * Update position data
     * @param   {[type]}  state  [state description]
     * @param   {[type]}  data   [data description]
     * @return  {[type]}         [return description]
     */
    UPDATE_POSITION_DATA(state, data) {
        data.map((item) => (item.id = item.Symbol + item.LP));
        state.positionData = data;
    },
    /**
     * Update lp list
     * @param   {[type]}  state  [state description]
     * @param   {[type]}  data   [data description]
     * @return  {[type]}         [return description]
     */
    UPDATE_LP_LIST(state, data) {
        const sorted = [...data].sort((a, b) => {
            const nameA = a.lp_name.split("] ")[1] ?? "";
            const nameB = b.lp_name.split("] ")[1] ?? "";
            return nameA.localeCompare(nameB);
        });
        const returnData = [...sorted];
        state.lpList = returnData;
    },
    /**
     * Update position rec data
     * @param   {[type]}  state  [state description]
     * @param   {[type]}  data   [data description]
     * @return  {[type]}         [return description]
     */
    UPDATE_REC_DATA(state, data) {
        state.recData = data;
    },
    /**
     * Assign value to symbol map
     * @param   {[type]}  state  [state description]
     * @param   {[type]}  data   [data description]
     * @return  {[type]}         [return description]
     */
    UPDATE_SYMBOL_MAP_DATA(state, data) {
        state.symbolMapData = data;
    },
    UPDATE_STATUS(state, data) {
        state.updateStatus = data;
    },
    UPDATE_BATCH_ADD_LP_ID(state, data) {
        state.batchAddLPId = data;
    },
};

const getters = {
    /**
     * Extract layout config
     * @param   {[type]}  state  [state description]
     * @param   {[type]}  alert  [alert description]
     * @return  {[type]}         [return description]
     */
    filterPositionData: (state) => (lp) => {
        return state.positionData;
    },
};

export default {
    namespaced: true,
    state,
    actions,
    getters,
    mutations,
};
